export const range = (amount: number) =>
  Array.from({ length: amount }, (_, i) => i + 1);
